module.exports = __webpack_public_path__ + "img/cover.3effe4d1.jpg";